import Swiper, { Navigation, Autoplay } from 'swiper';

import 'swiper/css/bundle';


const swiper = new Swiper('.industry-slider', {
    modules: [Navigation, Autoplay],
    loop: true,
    speed: 1000,
    slidesPerView: 1.1,
    spaceBetween: 8,

    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 4,
        },
    },

    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.swiper-next-btn',
        prevEl: '.swiper-prev-btn',
    },
});
